import { render, staticRenderFns } from "./LogRoundReceive.vue?vue&type=template&id=ca85836c&"
import script from "./LogRoundReceive.vue?vue&type=script&lang=js&"
export * from "./LogRoundReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports